<template>
  <VContainer class="parents-worked-in-uk-page">
    <VRow>
      <VCol cols="12">
        <div class="parents-worked-in-uk-page__content">
          <p>Did your Parents Work in the UK – even 70 years ago?</p>
          <p>Thousands of Older People are owed €10,000+ but don’t know it!</p>
          <p><b>People most affected are:</b></p>
          <ul>
            <li>Wives Who NEVER Lived in UK</li>
            <li>Widows Getting Husband's UK Pension</li>
            <li>Women Who Worked in the UK</li>
            <li>People Who NEVER Claimed UK Pension</li>
            <li>Stay-At-Home Mums in UK 1978-2010</li>
            <li>Wives Now Getting UK Pension</li>
          </ul>
          <p><i>This applies to Men 75+, Women 73+</i></p>
          <table class="table-border">
            <tbody>
              <tr>
                <td>
                  <div>
                    XtraPension recovers lump sums for older<br />
                    people on a ‘no win, no fee’ basis.
                  </div>
                </td>
                <td>
                  <div>
                    <router-link :to="{ name: 'Contact Us' }">Contact Us</router-link>
                    today to see how much <br />
                    your Mum / Dad / Friend might be owed.
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p><b>And - You get a free year of Pension Keeper if you refer someone who we help to get a Lump Sum!</b></p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'ParentsWorkedInUK',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar'])
  }
};
</script>
